import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  max-width: 300px;
  width: 100%;
  height: 190px:
  background: ffffff;
  box-shadow: 0px 30px 60px rgba(38, 46, 59, 0.3);
  border-radius: 20px;
`;

const Tittle = styled.h1``;

function Card(props) {
  const { index } = props;

  return (
    <Wrapper>
      <Tittle>{index + 1} </Tittle>
    </Wrapper>
  );
}

export default Card;



// WEBPACK FOOTER //
// ./src/card.js